import { getInternalOrganizationUserDetailsApi } from '@/api/v1/organization/internal/getInternalOrganizationUserDetailsApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import {
  EditInternalOrganizationUserPayloadType,
  editInternalOrganizationUserApi,
} from '@/api/v1/organization/internal/editInternalOrganizationUserApi';
import {
  editInternalOrganizationUserRoleApi,
  EditInternalOrganizationUserRolePayloadType,
} from '@/api/v1/organization/internal/editInternalOrganizationUserRoleApi';
import { blockInternalOrganizationUserApi } from '@/api/v1/organization/internal/blockInternalOrganizationUserApi';
import { unblockInternalOrganizationUserApi } from '@/api/v1/organization/internal/unblockInternalOrganizationUserApi';
import { reinviteInternalOrganizationUserApi } from '@/api/v1/organization/internal/reinviteInternalOrganizationUserApi';
import {
  EditInternalOrganizationUserMobilePhonePayloadType,
  editInternalOrganizationUserMobilePhoneApi,
} from '@/api/v1/organization/internal/editInternalOrganizationUserMobilePhoneApi';

export const getInternalOrganizationUserDetails = async (userId: string) => {
  try {
    const response = await getInternalOrganizationUserDetailsApi(userId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const editInternalOrganizationUserMobilePhone = async (
  userId: string,
  payload: EditInternalOrganizationUserMobilePhonePayloadType
) => {
  try {
    const response = await editInternalOrganizationUserMobilePhoneApi(userId, payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const editInternalOrganizationUser = async (
  userId: string,
  payload: EditInternalOrganizationUserPayloadType
) => {
  try {
    const response = await editInternalOrganizationUserApi(userId, payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const editInternalOrganizationUserRole = async (
  userId: string,
  payload: EditInternalOrganizationUserRolePayloadType
) => {
  try {
    const response = await editInternalOrganizationUserRoleApi(userId, payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const blockInternalOrganizationUser = async (userId: string) => {
  try {
    const response = await blockInternalOrganizationUserApi(userId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const unblockInternalOrganizationUser = async (userId: string) => {
  try {
    const response = await unblockInternalOrganizationUserApi(userId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const reinviteInternalOrganizationUser = async (userId: string) => {
  try {
    const response = await reinviteInternalOrganizationUserApi(userId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
